import Footer from '../base/footer';
import returnToTop from '../base/returnToTop';
import baidu from '../base/baidu';
import { registerProductPage } from '../base/product2026';

// 页面名 / 产品 ID 优先读 body[data-lead-page|data-lead-product-id]，再回退到子导航文案
registerProductPage();
